
import { Typography, Avatar, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, FormControl, Select, MenuItem } from '@mui/material'
// import VisibilityIcon from '@mui/icons-material/Visibility';
import { useLocation, useNavigate } from "react-router-dom";
import { useMemo, useState } from 'react';
import StatusEstabelecimento from "../../../../utils/status/statusEstabelecimento";
import ListaVazia from "../../../../utils/listaVazia";
import DateHora from "../../../../utils/dateHora";
import TempoPassado from "../../../../utils/tempoPassado";
import StatusEntrada from "../../../../utils/status/statusEntrada";
import { Paper } from "@mui/material";
import ProvinciaFilter from "../../../../filters/provinciaFilter";
import CategoriaFilter from "../../../../filters/categoriaFilter";
import SolicitacaoNomeEntradaFilter from "../../../../filters/solicitacaoNomeEntradaFilter";
import DataInicioFimFilter from "../../../../filters/dataInicio_dataFinal_Filter";

const useStyles = () => ({
    hover: { '&:hover': { backgroundColor: '#85287d8a' }, cursor: 'pointer' }
});

export default function ListaSolicitacao({ estabelecimentos, setEstabelecimentos, tipo, setTipo, provincia, setProvincia, setDataInicio, setDataFim, dataInicio, dataFim, children }) {
    const classes = useStyles()
    const navigate = useNavigate()
    const location = useLocation();
    const [ordemData, setOrdemData] = useState('recentes');

    const isReprovadasPage = location.pathname === '/admin/solicitacoes/reprovadas';

    const estabelecimentosOrdenados = useMemo(() => {
        const campoData = isReprovadasPage ? 'dataDespacho' : 'createdAt';
        const lista = Array.isArray(estabelecimentos) ? [...estabelecimentos] : [];

        return lista.sort((a, b) => {
            const dataA = new Date(a?.[campoData] || 0).getTime();
            const dataB = new Date(b?.[campoData] || 0).getTime();
            return ordemData === 'recentes' ? dataB - dataA : dataA - dataB;
        });
    }, [estabelecimentos, isReprovadasPage, ordemData]);

    // const Origem = origem ? <span style={{ fontSize: 10, color: '#000', marginLeft: 5, background: '#fff', padding: '2px 4px', borderRadius: 3 }}>({origem})</span> : null;

    return (
        <TableContainer sx={{ border: "1px black" }} component={Paper}>
            <Table sx={{ border: "1px", borderColor: "black" }}>
                <TableHead sx={{ backgroundColor: "#dcdede" }}>
                    <TableRow>
                        <TableCell ><Typography noWrap> <strong>Imagem</strong></Typography></TableCell>
                        <TableCell ><Typography display={'flex'} alignItems={'center'} noWrap>
                            <strong>Nome</strong>
                            <SolicitacaoNomeEntradaFilter setEstabelecimentos={setEstabelecimentos} placeholder={'Filtar por nome'} />
                        </Typography></TableCell>
                        <TableCell ><Typography display={'flex'} alignItems={'center'} noWrap>
                            <strong>Tipo</strong>
                            <CategoriaFilter tipo={tipo} setTipo={setTipo} />
                        </Typography></TableCell>
                        <TableCell ><Typography display={'flex'} alignItems={'center'} noWrap>
                            <strong>Nº de entrada</strong>
                            <SolicitacaoNomeEntradaFilter setEstabelecimentos={setEstabelecimentos} placeholder={'Filtar por Nº de entrada'} />
                        </Typography></TableCell>
                        {/* <TableCell ><Typography noWrap> <strong>Número de Processo</strong></Typography></TableCell> */}
                        <TableCell ><Typography noWrap> <strong>Director técnico</strong></Typography></TableCell>
                        <TableCell ><Typography display={'flex'} alignItems={'center'} noWrap>
                            <strong>Provincia</strong>
                            <ProvinciaFilter provincia={provincia} setProvincia={setProvincia} />
                        </Typography></TableCell>
                        <TableCell ><Typography noWrap> <strong>Solicitação</strong></Typography></TableCell>
                        <TableCell ><Typography noWrap> <strong>Estado</strong></Typography></TableCell>
                        <TableCell ><Typography display={'flex'} alignItems={'center'} noWrap>
                            {isReprovadasPage ? <strong>Data de reprovação</strong> : <strong>Data de entrada</strong>}
                            <DataInicioFimFilter setDataInicio={setDataInicio} setDataFim={setDataFim} dataInicio={dataInicio} dataFim={dataFim} />
                            <FormControl size="small" sx={{ minWidth: 145, ml: 1, }}>
                                <Select
                                    value={ordemData}
                                    onChange={(e) => setOrdemData(e.target.value)}
                                    displayEmpty
                                    title="Ordenar processos por data"
                                    sx={{ p: 0, m: 0, color: '#000' }}
                                    variant='standard'
                                >
                                    <MenuItem value="recentes">Mais recentes</MenuItem>
                                    <MenuItem value="antigos">Mais antigos</MenuItem>
                                </Select>
                            </FormControl>
                        </Typography></TableCell>
                        <TableCell ><Typography noWrap> <strong>Ultima intervenção</strong></Typography></TableCell>
                    </TableRow>
                </TableHead>

                <TableBody>
                    {estabelecimentosOrdenados.map((estabelecimento) => (
                        <TableRow key={estabelecimento?._id} style={classes.hover} onClick={() => navigate(`/admin/analise/solicitacao-de-licenciamento/${estabelecimento?._id}`)} title={estabelecimento?.nome}>

                            <TableCell component="th" scope="row">
                                <Avatar variant="square" src={estabelecimento?.logo} alt={estabelecimento?.nome} />
                            </TableCell>

                            <TableCell >
                                {estabelecimento?.nome}
                                {estabelecimento?.external?.nome && (
                                    <span style={{ fontSize: 10, color: '#000', marginLeft: 5, background: '#85287d8a', padding: '2px 4px', borderRadius: 3 }}>
                                        ({estabelecimento?.external?.nome})
                                    </span>
                                )}

                            </TableCell>
                            <TableCell >{estabelecimento?.tipo?.designacao}</TableCell>
                            <TableCell >{estabelecimento?.numeroEntrada}</TableCell>
                            {/* <TableCell >{estabelecimento?.numeroProcesso}</TableCell> */}
                            <TableCell >{estabelecimento?.directorTecnico?.dadosPessoais?.nome}</TableCell>
                            <TableCell >{estabelecimento?.provincia}</TableCell>
                            <TableCell ><StatusEntrada status={estabelecimento?.tipoEntrada} />  </TableCell>
                            <TableCell >  <StatusEstabelecimento status={estabelecimento?.status} /></TableCell>
                            <TableCell ><DateHora date={isReprovadasPage ? estabelecimento?.dataDespacho : estabelecimento?.createdAt} /> </TableCell>
                            <TableCell ><TempoPassado date={estabelecimento?.updatedAt} /> </TableCell>
                            {/* <TableCell > <Typography noWrap> {estabelecimento?.email}</Typography></TableCell> */}
                        </TableRow>
                    ))}
                </TableBody>
            </Table>

            {estabelecimentosOrdenados.length < 1 && <ListaVazia text={'DE MOMENTO NÃO HÁ SOLICITACÕES PARA O SEU PERFIL INTERVIR'} />}

            {children}
        </TableContainer>
    )
}